
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import SystemModule from "@/store/modules/system";
import { getModule } from "vuex-module-decorators";
import AgentUserEdit from "../../views/admin/AgentUserEdit.vue";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    AgentUserEdit
  }
})
export default class UserEditModal extends Vue {
    isVisible: boolean = false;
    id: string = null;
    
    @Prop()
    agentId: number | null;

    public saveAgentUser(bvModalEvent) {
        bvModalEvent.preventDefault();
        const modal = this.$refs.AgentUserEditModel as AgentUserEdit;
        modal.save();
    }

    UserUpdated() {
        this.$emit("UserUpdated");
        this.isVisible = false;
    }

    public show(id: string) {
        this.id = id;
        this.isVisible = true;
    }
}
